import { createContext as t, useContext as n } from "react";
const e = "/pubweb-assets/horizon/Icons", s = t(null);
function r() {
  return n(s);
}
function u() {
  var o;
  return ((o = r()) == null ? void 0 : o.svgBaseURL) ?? e;
}
export {
  e as HORIZON_SVG_BASE_URL,
  s as HorizonContext,
  r as useHorizonContext,
  u as useHorizonSvgBaseURL
};
